import styled from 'styled-components';

export default styled.div`
	display: flex;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%);
`;
